// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__yx4nx","unreadBadge":"styles_unreadBadge__3ZVnL","modalContent":"styles_modalContent__1ITLG","modal":"styles_modal__3SbJk"};